import React, { useState } from 'react';

const SEZONE = ['2025/2026', '2026/2027'];

const praznaForma = (sezona) => ({
  naziv: '',
  datum: '',
  sezona: sezona || '2025/2026',
  nastupnici: [],
});

function Turniri({ turniri, igraci, dodajTurnir, updateTurnir, obrisiTurnir, setAktivna, globalnaSezona, jeAdmin }) {
  const [filterSezona, setFilterSezona] = useState('svi');
  const [prikaz, setPrikaz] = useState('lista'); // 'lista' | 'unos'
  const [forma, setForma] = useState(praznaForma(globalnaSezona));
  const [editId, setEditId] = useState(null);
  const [noviNastupnik, setNoviNastupnik] = useState({ igracId: '', rezultat: '', napomena: '' });

  // Jedinstveni nazivi turnira iz svih unesenih nastupa — za autocomplete
  const poznatTurniri = [...new Set(turniri.map(t => t.naziv).filter(Boolean))].sort();

  const filtrirani = turniri
    .filter(t => filterSezona === 'svi' || t.sezona === filterSezona)
    .sort((a, b) => (b.datum || '').localeCompare(a.datum || ''));

  // Statistika nastupa po turniru (za izvještaj "koliko gdje imamo nastupa")
  const nastupPoTurniru = {};
  turniri.forEach(t => {
    const kljuc = t.naziv;
    if (!nastupPoTurniru[kljuc]) nastupPoTurniru[kljuc] = { naziv: kljuc, odlasci: new Set(), igraca: 0, sezone: new Set() };
    // Isti datum = isti odlazak
    nastupPoTurniru[kljuc].odlasci.add(t.datum || t.id);
    nastupPoTurniru[kljuc].igraca += (t.nastupnici || []).length;
    nastupPoTurniru[kljuc].sezone.add(t.sezona);
  });
  const turnirskaStatistika = Object.values(nastupPoTurniru)
    .sort((a, b) => b.igraca - a.igraca)
    .map(s => ({ ...s, odlasci: s.odlasci.size, sezone: s.sezone.size }));

  // Top nastupnici — sve sezone
  const nastupiBrojac = {};
  turniri.forEach(t => {
    (t.nastupnici || []).forEach(n => {
      if (!n.igracId) return;
      if (!nastupiBrojac[n.igracId]) nastupiBrojac[n.igracId] = { igracId: n.igracId, ime: n.ime, ukupno: 0, sezone: new Set() };
      nastupiBrojac[n.igracId].ukupno += 1;
      nastupiBrojac[n.igracId].sezone.add(t.sezona);
    });
  });
  const topNastupnici = Object.values(nastupiBrojac)
    .sort((a, b) => b.ukupno - a.ukupno)
    .slice(0, 10)
    .map(n => ({ ...n, sezone: n.sezone.size }));

  const handleSacuvaj = async () => {
    if (!forma.naziv) return alert('Unesi naziv / lokaciju turnira!');
    if (forma.nastupnici.length === 0) return alert('Dodaj barem jednog nastupnika!');
    if (editId) {
      await updateTurnir(editId, forma);
      setEditId(null);
    } else {
      await dodajTurnir(forma);
    }
    setForma(praznaForma(filterSezona === 'svi' ? globalnaSezona : filterSezona));
    setPrikaz('lista');
  };

  const handleEdit = (t) => {
    setForma({ naziv: t.naziv, datum: t.datum || '', sezona: t.sezona, nastupnici: [...(t.nastupnici || [])] });
    setEditId(t.id);
    setNoviNastupnik({ igracId: '', rezultat: '', napomena: '' });
    setPrikaz('unos');
  };

  const dodajNastupnika = () => {
    if (!noviNastupnik.igracId) return alert('Odaberi igrača!');
    if (forma.nastupnici.find(n => n.igracId === noviNastupnik.igracId)) return alert('Igrač je već dodan!');
    const igrac = igraci.find(i => i.id === noviNastupnik.igracId);
    if (!igrac) return;
    setForma(prev => ({
      ...prev,
      nastupnici: [...prev.nastupnici, {
        igracId: noviNastupnik.igracId,
        ime: igrac.ime,
        rezultat: parseInt(noviNastupnik.rezultat) || 0,
        napomena: noviNastupnik.napomena || '',
      }],
    }));
    setNoviNastupnik({ igracId: '', rezultat: '', napomena: '' });
  };

  const ukloniNastupnika = (igracId) =>
    setForma(prev => ({ ...prev, nastupnici: prev.nastupnici.filter(n => n.igracId !== igracId) }));

  const medalja = (i) => {
    if (i === 0) return { emoji: '🥇', color: '#ffd700' };
    if (i === 1) return { emoji: '🥈', color: '#c0c0c0' };
    if (i === 2) return { emoji: '🥉', color: '#cd7f32' };
    return { emoji: null, color: '#e0e0f0' };
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
        <div className="page-title" style={{ margin: 0 }}>Turniri</div>
        {jeAdmin && prikaz === 'lista' && (
          <button className="btn-primary btn-sm" onClick={() => {
            setEditId(null);
            setForma(praznaForma(filterSezona === 'svi' ? globalnaSezona : filterSezona));
            setNoviNastupnik({ igracId: '', rezultat: '', napomena: '' });
            setPrikaz('unos');
          }}>+ Nastup na turniru</button>
        )}
        {prikaz === 'unos' && (
          <button className="btn-secondary btn-sm" onClick={() => { setPrikaz('lista'); setEditId(null); }}>← Nazad</button>
        )}
      </div>

      <div className="filter-bar" style={{ marginBottom: '20px' }}>
        {['svi', ...SEZONE].map(s => (
          <button key={s} className={'filter-btn ' + (filterSezona === s ? 'active' : '')}
            onClick={() => setFilterSezona(s)}>{s === 'svi' ? 'Sve sezone' : s}</button>
        ))}
      </div>

      {/* Ljestvica nastupnika — na vrhu */}
      {prikaz === 'lista' && topNastupnici.length > 0 && (
        <div className="card" style={{ marginBottom: '20px', borderLeft: '3px solid #ffd700' }}>
          <div className="section-title" style={{ marginBottom: '16px' }}>🏆 Najaktivniji na turnirima</div>
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            {topNastupnici.slice(0, 3).map((n, i) => {
              const m = medalja(i);
              const igrac = igraci.find(ig => ig.id === n.igracId);
              return (
                <div key={n.igracId}
                  style={{ flex: 1, minWidth: '130px', padding: '14px 12px', background: '#0d0d1f', borderRadius: '10px', border: '1px solid #2a2a4a', textAlign: 'center', cursor: 'pointer' }}
                  onClick={() => setAktivna({ strana: 'profil', igracId: n.igracId })}>
                  <div style={{ fontSize: '26px', marginBottom: '4px' }}>{m.emoji}</div>
                  <div style={{ fontSize: '30px', fontWeight: '700', color: m.color, lineHeight: 1 }}>{n.ukupno}</div>
                  <div style={{ fontSize: '10px', color: '#666688', textTransform: 'uppercase', margin: '3px 0 7px', letterSpacing: '1px' }}>nastupa</div>
                  <div style={{ fontSize: '13px', fontWeight: '700', color: '#fff' }}>{n.ime}</div>
                  {igrac && <div style={{ fontSize: '11px', color: '#666688', marginTop: '2px' }}>{igrac.klub}</div>}
                </div>
              );
            })}
            {topNastupnici.slice(3).length > 0 && (
              <div style={{ flex: 2, minWidth: '180px', display: 'flex', flexDirection: 'column', gap: '5px', justifyContent: 'center' }}>
                {topNastupnici.slice(3).map((n, i) => {
                  const igrac = igraci.find(ig => ig.id === n.igracId);
                  return (
                    <div key={n.igracId}
                      style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 10px', background: '#0d0d1f', borderRadius: '6px', cursor: 'pointer' }}
                      onClick={() => setAktivna({ strana: 'profil', igracId: n.igracId })}>
                      <span style={{ fontSize: '12px', color: '#555566', minWidth: '20px' }}>{i + 4}.</span>
                      <span style={{ fontSize: '13px', color: '#fff', flex: 1 }}>{n.ime}</span>
                      {igrac && <span style={{ fontSize: '11px', color: '#666688' }}>{igrac.klub}</span>}
                      <span style={{ fontSize: '15px', fontWeight: '700', color: '#e94560' }}>{n.ukupno}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Statistika po turniru */}
      {prikaz === 'lista' && turnirskaStatistika.length > 0 && (
        <div className="card" style={{ marginBottom: '20px' }}>
          <div className="section-title" style={{ marginBottom: '12px' }}>📊 Nastup po turniru</div>
          <div style={{ overflowX: 'auto' }}>
            <table>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>Turnir / Lokacija</th>
                  <th style={{ textAlign: 'center', width: '110px' }}>Odlazak na turnir</th>
                  <th style={{ textAlign: 'center', width: '110px' }}>Ukupno nastupa</th>
                </tr>
              </thead>
              <tbody>
                {turnirskaStatistika.map(s => (
                  <tr key={s.naziv}>
                    <td style={{ fontWeight: '600', color: '#fff' }}>{s.naziv}</td>
                    <td style={{ textAlign: 'center', fontWeight: '700', color: '#e94560', fontSize: '16px' }}>{s.odlasci}</td>
                    <td style={{ textAlign: 'center', color: '#aaa' }}>{s.igraca}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Lista nastupa */}
      {prikaz === 'lista' && (
        filtrirani.length === 0 ? (
          <div className="card empty-state">
            <div className="icon">🏆</div>
            <p>Nema unesenih nastupa{filterSezona !== 'svi' ? ` za sezonu ${filterSezona}` : ''}</p>
            {jeAdmin && (
              <button className="btn-primary" style={{ marginTop: '12px' }}
                onClick={() => { setEditId(null); setForma(praznaForma(globalnaSezona)); setPrikaz('unos'); }}>
                + Nastup na turniru
              </button>
            )}
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {filtrirani.map(t => {
              const sortiraniNastupnici = [...(t.nastupnici || [])].sort((a, b) => (b.rezultat || 0) - (a.rezultat || 0));
              return (
                <div key={t.id} className="card" style={{ borderLeft: '3px solid #e94560' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                    <div>
                      <div style={{ fontSize: '16px', fontWeight: '700', color: '#fff', marginBottom: '3px' }}>{t.naziv}</div>
                      <div style={{ fontSize: '12px', color: '#666688' }}>
                        {t.datum && <span>{t.datum} · </span>}
                        <span style={{ color: '#e94560' }}>{t.sezona}</span>
                        <span style={{ marginLeft: '8px', color: '#555566' }}>· {(t.nastupnici || []).length} nastupnik{(t.nastupnici || []).length !== 1 ? 'a' : ''}</span>
                      </div>
                    </div>
                    {jeAdmin && (
                      <div style={{ display: 'flex', gap: '6px' }}>
                        <button className="btn-secondary btn-sm" onClick={() => handleEdit(t)}>✏️</button>
                        <button className="btn-danger btn-sm"
                          onClick={() => { if (window.confirm('Obrisati nastup?')) obrisiTurnir(t.id); }}>✕</button>
                      </div>
                    )}
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {sortiraniNastupnici.map((n, i) => (
                      <div key={n.igracId}
                        style={{ padding: '9px 13px', background: '#0d0d1f', borderRadius: '8px', border: '1px solid ' + (i === 0 && sortiraniNastupnici.length > 1 && n.rezultat > 0 ? '#ffd700' : '#2a2a4a'), cursor: 'pointer', minWidth: '120px' }}
                        onClick={() => setAktivna({ strana: 'profil', igracId: n.igracId })}>
                        {i === 0 && sortiraniNastupnici.length > 1 && n.rezultat > 0 && (
                          <div style={{ fontSize: '10px', color: '#ffd700', fontWeight: '700', marginBottom: '2px', letterSpacing: '1px' }}>BEST ★</div>
                        )}
                        <div style={{ fontSize: '13px', fontWeight: '600', color: '#fff' }}>{n.ime}</div>
                        {n.rezultat > 0 && (
                          <div style={{ fontSize: '20px', fontWeight: '700', color: i === 0 && sortiraniNastupnici.length > 1 ? '#ffd700' : '#e94560', lineHeight: 1.2 }}>{n.rezultat}</div>
                        )}
                        {n.napomena && <div style={{ fontSize: '11px', color: '#888', marginTop: '2px' }}>{n.napomena}</div>}
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )
      )}

      {/* Forma za unos/edit */}
      {prikaz === 'unos' && (
        <div className="card" style={{ maxWidth: '660px' }}>
          <div className="section-title">{editId ? 'Uredi nastup' : 'Nastup na turniru'}</div>

          <div className="form-row">
            <div className="form-group" style={{ flexBasis: '100%' }}>
              <label>Turnir / Lokacija</label>
              {/* Datalist: postojeći turniri + mogućnost novog */}
              <input
                list="poznatTurniriList"
                placeholder={poznatTurniri.length > 0 ? 'Odaberi postojeći ili unesi novi...' : 'npr. Grand Prix Sarajevo'}
                value={forma.naziv}
                onChange={e => setForma({ ...forma, naziv: e.target.value })}
                style={{ width: '100%' }}
                autoComplete="off"
              />
              <datalist id="poznatTurniriList">
                {poznatTurniri.map(n => <option key={n} value={n} />)}
              </datalist>
              {poznatTurniri.length > 0 && (
                <div style={{ fontSize: '11px', color: '#555566', marginTop: '4px' }}>
                  Poznati turniri: {poznatTurniri.join(' · ')}
                </div>
              )}
            </div>
            <div className="form-group">
              <label>Datum</label>
              <input type="date" value={forma.datum}
                onChange={e => setForma({ ...forma, datum: e.target.value })} />
            </div>
            <div className="form-group">
              <label>Sezona</label>
              <select value={forma.sezona} onChange={e => setForma({ ...forma, sezona: e.target.value })}>
                {SEZONE.map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
          </div>

          {/* Nastupnici */}
          <div style={{ marginTop: '16px', borderTop: '1px solid #2a2a4a', paddingTop: '16px' }}>
            <div style={{ fontSize: '11px', color: '#666688', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '10px' }}>
              Nastupnici ({forma.nastupnici.length})
            </div>

            {forma.nastupnici.length > 0 && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', marginBottom: '12px' }}>
                {forma.nastupnici.map(n => (
                  <div key={n.igracId} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '7px 12px', background: '#0d0d1f', borderRadius: '6px', border: '1px solid #2a2a4a' }}>
                    <span style={{ flex: 1, fontSize: '14px', fontWeight: '600', color: '#fff' }}>{n.ime}</span>
                    {n.rezultat > 0 && <span style={{ fontSize: '17px', fontWeight: '700', color: '#e94560' }}>{n.rezultat}</span>}
                    {n.napomena && <span style={{ fontSize: '12px', color: '#888' }}>{n.napomena}</span>}
                    <button onClick={() => ukloniNastupnika(n.igracId)}
                      style={{ background: 'none', border: 'none', color: '#e94560', cursor: 'pointer', fontSize: '18px', lineHeight: 1, padding: '0 2px' }}>×</button>
                  </div>
                ))}
              </div>
            )}

            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'flex-end', padding: '12px', background: '#0d0d1f', borderRadius: '8px', border: '1px dashed #2a2a4a' }}>
              <div className="form-group" style={{ margin: 0 }}>
                <label>Igrač</label>
                <select value={noviNastupnik.igracId}
                  onChange={e => setNoviNastupnik({ ...noviNastupnik, igracId: e.target.value })}>
                  <option value="">— Odaberi —</option>
                  {[...igraci].sort((a, b) => a.ime.localeCompare(b.ime)).map(i => (
                    <option key={i.id} value={i.id}>{i.ime} ({i.klub})</option>
                  ))}
                </select>
              </div>
              <div className="form-group" style={{ margin: 0 }}>
                <label>Ukupan rezultat</label>
                <input type="number" placeholder="npr. 1250" value={noviNastupnik.rezultat}
                  onChange={e => setNoviNastupnik({ ...noviNastupnik, rezultat: e.target.value })}
                  style={{ width: '120px' }} />
              </div>
              <div className="form-group" style={{ margin: 0 }}>
                <label>Napomena</label>
                <input placeholder="npr. 3. mjesto" value={noviNastupnik.napomena}
                  onChange={e => setNoviNastupnik({ ...noviNastupnik, napomena: e.target.value })}
                  style={{ width: '130px' }} />
              </div>
              <button className="btn-secondary" onClick={dodajNastupnika}>+ Dodaj igrača</button>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '10px', marginTop: '18px' }}>
            <button className="btn-primary" onClick={handleSacuvaj}>{editId ? 'Sačuvaj izmjene' : 'Sačuvaj nastup'}</button>
            <button className="btn-secondary" onClick={() => { setPrikaz('lista'); setEditId(null); }}>Odustani</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Turniri;
